export default __webpack_public_path__ + "static/media/74_mobile.f2efee74.jpg";